import Vue from 'vue';

import router from './router';
import store from './store';
import VueKindergarten from 'vue-kindergarten';

Vue.use(VueKindergarten, {
	child: (store) => {
		return store.getters.getUser
	}
});

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import VShowSlide from 'v-show-slide';
Vue.use(VShowSlide);

Vue.use(VueForm, {
	validators
});

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');

import VueForm from 'vue-form';
import './assets/sass/app.scss';
import validators from './validators';

import App from './App.vue';

import formatDateFilter from './filters/formatDate';
import formatNumber from './filters/formatNumber';
import formatCurrency from './filters/formatCurrency';
import formatBytes from './filters/formatBytes';
import formatCapitalize from './filters/formatCapitalize';

Vue.filter('formatDate', formatDateFilter);
Vue.filter('formatNumber', formatNumber);
Vue.filter('formatBytes', formatBytes);
Vue.filter('formatCurrency', formatCurrency);
Vue.filter('formatCapitalizeFirstLetter', formatCapitalize.formatCapitalizeFirstLetter);
Vue.filter('capitalizeTheFirstLetterOfEachWord', formatCapitalize.capitalizeTheFirstLetterOfEachWord);
Vue.filter('splitCamelCaseAndCapitalize', formatCapitalize.splitCamelCaseAndCapitalize);

let handleOutsideClick;
Vue.directive('click-outside', {
	bind(el, binding, vnode) {
		handleOutsideClick = (e) => {
			e.stopPropagation();
			let { handler, exclude } = binding.value;
			let clickedOnExcludedEl = false;
			exclude.forEach(refName => {
				if (!clickedOnExcludedEl) {
					let excludedEl = null;
					if (vnode.context.$refs[refName]) {
						excludedEl = vnode.context.$refs[refName];
						clickedOnExcludedEl = excludedEl.contains(e.target);
					} else if (vnode.context.$parent.$refs[refName]) {
						excludedEl = vnode.context.$parent.$refs[refName];
						clickedOnExcludedEl = excludedEl.contains(e.target);
					}
				}
			});
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				vnode.context[handler](e);
			}
		};
		document.addEventListener('click', handleOutsideClick)
		document.addEventListener('touchstart', handleOutsideClick)
	},
	unbind() {
		document.removeEventListener('click', handleOutsideClick)
		document.removeEventListener('touchstart', handleOutsideClick)
	}
});

// import the styles
import 'vue-good-table/dist/vue-good-table.css'